module.exports = __webpack_public_path__ + "img/stage-move-icon.b6c2f401.svg";